<template>
  <div class="home">
    <BigHeader />
    <Intro />
    <div style="margin-top: 5rem; overflow: auto;padding: 0 1.5rem;width: 100%;display: flex;justify-content: center;">
      <iframe
          id="host-websites-widget"
          class="responsive-iframe"
          src="https://widget.holiduhost.com/widget/6d02e93b-28eb-4efe-a44f-4ae9c12fb951"
          @load="onIframeLoad">
      >
      </iframe>
    </div>
    <!--div class="container mt-6">
      <div class="columns is-vcentered has-text-centered">
        <div class="column is-half">
          <div class="mt-5 container is-centered has-text-centered">
            <a class="button is-size-3" href="https://www.holidu.de/d/54057338" target="_blank">Bühl "Städtle" - Buchung</a>
          </div>
        </div>
        <div class="column is-half">
          <div class="mt-5 container is-centered has-text-centered">
            <a class="button is-size-3" href="https://www.holidu.de/d/54046360" target="_blank">Ottersweier "Dörfle" - Buchung</a>
          </div>
        </div>
      </div>
    </div-->
  </div>
</template>

<style>
.responsive-iframe {
  width: 80%;
  height: 1400px; /* Default height */
}

@media (max-width: 1024px) {
  .responsive-iframe {
    height: 1400px; /* Height for tablets */
  }
}

@media (max-width: 768px) {
  .responsive-iframe {
    height: 2300px; /* Height for mobile devices */
  }
}

@media (max-width: 480px) {
  .responsive-iframe {
    height: 2400px; /* Height for mobile devices */
  }
}
</style>

<script>

import BigHeader from "@/components/BigHeader";
import Intro from "@/components/Intro";
import Gallery from "@/components/GalleryOttersweier.vue";
import Booking from "@/components/Booking";

export default {
  name: 'Home',
  components: {
    Intro,
    BigHeader,
    Gallery,
    Booking
  }
}
</script>
